export default class ProductCard {
    constructor(card) {
        this.toggleButton = card.querySelector('[data-card-toggle]');
        this.toggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            card.classList.toggle('is-open');
            this.toggleButton.classList.toggle('is-open');
        });
    }
}
